import { DEFAULT_PRODUCT_UNIT_CODE } from '../constants/defaultProduct'
import type { ProductUnit } from '../types/productUnit'
import { getProductUnitCode } from './getProductUnitCode'

export const getDefaultProductUnitName = (units: ProductUnit[] = []): string => {
  const pieceUnit = units.find((unit) => getProductUnitCode(unit) === DEFAULT_PRODUCT_UNIT_CODE)
  const defaultUnit = pieceUnit ?? units[0]

  return defaultUnit?.name ?? ''
}
